import { Status } from "components";
import { PhosphorEnvelopeSimple, PhosphorPhone, PhosphorWarningInline } from "components/Atoms/PhosphorIcon";
import CultureFlag from "components/Culture/CultureFlag";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import TagList from "components/Tag/TagList";
import React from "react";

const StatusAndPositionElement = ({ item, displayStatus }: { item: server.dto.ContactForList, displayStatus: boolean }) => {
  return <div className="flex-column gap-small">
    {displayStatus && <div><Status status={item.status} small /></div>}
    <div>{item.position}</div>
  </div>;
};

const ContactDetailsElement = ({ item }: { item: server.dto.ContactForList }) => {
  return <div className="flex-column gap-small">
    {(item.primaryEmail) && <div className="flex gap">
      <div>
        <PhosphorEnvelopeSimple iconColor="gray" />
      </div>
      <div>
        {item.primaryEmail}
      </div>
    </div>}

    {(item.primaryMobile) && <div className="flex gap">
      <div>
        <PhosphorPhone iconColor="gray" />
      </div>
      <div>
        {item.primaryMobile}
      </div>
    </div>}
  </div>;
};

const WorksAtElement = ({ item }: { item: server.dto.ContactForList }) => {
  return (
    <div>
      <div>
        <a href={item.worksAtDetailUrl}>{item.worksAtLabel}</a>
        <span style={{ marginLeft: 5 }}>{item.worksAtCount}</span>
      </div>
      <div className="text-sublabel">{item.worksAtCityCountry}</div>
    </div>
  );
};

export const cardLayout = (viewModel: server.viewmodel.ContactListFrontModel): ListTemplateLayout<server.dto.ContactForList> => ({
  type: "card",
  sections: {
    renderTitle: item => <ContactSidePanel
      contactId={item.contactId}
      trigger={<LargeClickableTitle
        iconTitleGap="gap"
        icon={<>
          <CultureFlag lcid={item.culture} />
          {!item.isValidated && <PhosphorWarningInline />}
        </>}
        title={item.name.fullName}
      />}
    />,
    hideTitle: () => false,
    renderBody: item => <>
      <StatusAndPositionElement item={item} displayStatus={viewModel.statuses.length > 1} />
      <ContactDetailsElement item={item} />
      <WorksAtElement item={item} />
    </>,
    renderFooter: item => <TagList tags={item.tags} version="short" />,
    hideFooter: item => item.tags.length === 0
  }
});